import Divider from "antd/es/divider"
import Skeleton from "antd/es/skeleton"

const FeedLoadingState = () => {
  return (
    <div className="flex w-full flex-col overflow-hidden">
      <div className="w-full pr-4">
        <Skeleton
          className="mt-4 w-full p-4"
          loading
          paragraph={{ rows: 2 }}
          avatar={false}
          title={false}
          active
        />
      </div>
      <Divider />
      <div className="flex w-full gap-2 overflow-hidden pl-2 pr-4">
        <div className="flex grow flex-col gap-4">
          {[...Array<number>(4)].map((_, index) => (
            <Skeleton
              key={index}
              className="rounded-lg border-2 border-gray-200 bg-white p-4 shadow-sm"
              loading
              paragraph={{ rows: 3 }}
              avatar
              active
            />
          ))}
        </div>

        <div className="flex w-[30rem] flex-col gap-4 overflow-y-hidden">
          {[...Array<number>(4)].map((_, index) => (
            <div key={index} className="rounded-xl bg-gray-50 p-4">
              <div className="mb-2 flex items-center">
                <Skeleton.Avatar active size="small" />
                <div className="ml-2 flex-grow">
                  <Skeleton.Input className="3/4" active size="small" />
                </div>
              </div>
              <Skeleton paragraph={{ rows: 2 }} active />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FeedLoadingState
